// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collection-layout[data-v-5caefe37] {\n  /* border: 1px solid #ebebeb; */\n  background: #fff;\n}\n.collection-layout[data-v-5caefe37] .el-result__title {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
